import React from 'react';

const SvgSnapchat = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.56 1.5c1.78 0 2.83.94 3.25 2.9.08.38.12.74.14 1.12.01.21.02.41.02.6 0 .08.02.12.09.15.26.1.51.08.77.03.29-.06.55.01.76.23.21.22.28.48.2.77-.07.26-.24.44-.5.52-.14.04-.28.06-.42.09-.44.08-.87.19-1.29.35-.13.05-.24.13-.34.22-.68.64-1.48 1.08-2.4 1.32-.35.09-.71.13-1.07.13-.74 0-1.44-.17-2.12-.45-.45-.19-.85-.46-1.22-.78-.13-.11-.28-.2-.44-.26-.39-.14-.79-.23-1.2-.3-.56-.09-.93-.58-.87-1.13.05-.44.43-.8.93-.82.14 0 .29.01.43.03.22.03.43.03.64-.03.08-.02.1-.05.1-.13.01-.32.03-.65.06-.97.07-.73.22-1.44.55-2.1.62-1.26 1.64-2.02 3-2.35.27-.06.53-.09.8-.11h.39Zm0 11.83c-.1 0-.2 0-.3-.01-.62-.05-1.18-.27-1.7-.59-.23-.14-.44-.31-.65-.48-.1-.08-.21-.1-.33-.08-.34.06-.67.14-1 .27-.27.1-.5.25-.68.48-.26.33-.33.7-.14 1.09.14.29.39.47.68.59.29.12.6.19.91.24.29.05.57.1.86.14.09.01.16.05.2.13.14.24.35.39.61.47.25.08.51.11.77.14.41.05.83.08 1.24.14.32.05.62.14.91.27.24.11.49.21.78.21h.08c.29-.01.54-.1.78-.21.3-.13.6-.22.92-.27.41-.06.83-.09 1.24-.14.26-.03.52-.06.77-.14.26-.08.47-.24.6-.47.05-.08.11-.12.2-.13.29-.04.58-.09.86-.14.31-.05.62-.12.91-.24.29-.12.54-.3.68-.59.19-.39.12-.76-.14-1.09-.18-.23-.41-.38-.68-.48-.33-.13-.66-.21-1-.27-.12-.02-.23 0-.33.08-.21.17-.42.34-.66.48-.51.32-1.07.54-1.69.59-.1.01-.2.01-.3.01h-.08-.07Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgSnapchat;
